import {collection, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class CustomObjectTypeCustomObjectData extends EntityData<CustomObjectTypeCustomObjectData> {
    @identifier customObjectId: number;
    @field name: string;
    @field description: string;
}

export class CustomObjectTypeData extends EntityData<CustomObjectTypeData> {
    @identifier customObjectTypeId: number;
    @field name: string;
    @field description: string;
    @field searchable: boolean;
    @field productLineContext: boolean;
    @field inventoryContext: boolean;
    @field outletContext: boolean;
    @field membershipTypeContext: boolean;
    @field discontinued: boolean;
    @collection() customFields: string[];
    @collection(CustomObjectTypeCustomObjectData) customObjects: CustomObjectTypeCustomObjectData[];
}

export class CustomObjectTypeReferenceData extends EntityData<CustomObjectTypeReferenceData> {
    @identifier customObjectTypeId: number;
    @field name: string;
}
